<template>
  <div v-if="modal.isShow">
    <i-modal v-model="modal.isShow" am-instuction-modal>
      <template #header>
        <div />
      </template>
      <img
        v-if="modal.url"
        class="_margin-bottom:1/2"
        :src="modal.url"
      />
      <div
        v-html="modal.svg"
        am-svg
      />
    </i-modal>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, onUnmounted, onMounted } from 'vue'
const store = useStore()

const modal = computed(() => {
  return store.state.instructions.modal
})
const close = () => {
  store.state.instructions.modal.isShow = false
}
onMounted(() => {
  store.commit('ui/closeModal', close)
})
onUnmounted(() => {
  store.commit('ui/closeModal', null)
})
</script>

<style lang="scss">
[am-instuction-modal] {
  .modal {
    max-width: 90% !important;
    max-height: 90% !important;
  }
  img {
    max-height: calc(100vh - 160px);
    max-width: 100%;
    object-fit: contain;
    width: 100%;
    height: 100%;
    // max-height: calc(100vh - 160px)
  }
  [am-svg] {
    text-align: center;
    svg {
      max-height: calc(100vh - 160px);
      max-width: 100%;
    }
  }
}
</style>
